module.exports = __webpack_public_path__ + "370c1b73fa0cc89df58b39183ec042b5.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/icons/icon-calendar.png
// module id = 3207
// module chunks = 69